module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_15.5db6f329.png";